import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useSnackbar } from "notistack";
import { Search, SentimentDissatisfied } from "@mui/icons-material";
import axios from "axios";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard";
import Cart, { generateCartItemsFrom } from "./Cart";

const Products = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [debounceTimeout, setDebounceTimeout] = useState(null);
  const [items, setItems] = useState([]);
  const token = localStorage.getItem("token");

  useEffect(() => {
    performAPICall();
    // setDataLoaded("loaded");
  }, []);

  useEffect(() => {
    // const onLoadHandler = async () => {
    //   const productsData = await performAPICall();
    //   const cartData = await fetchCart(token);
    //   const cartDetails = generateCartItemsFrom(cartData, productsData);
    //   setItems(cartDetails);
    // };
    // onLoadHandler();
    fetchCart(localStorage.getItem("token"))
      .then((cartItems) => {
        return generateCartItemsFrom(cartItems, products);
      })
      .then((res) => {
        console.log(res);
        setItems(res);
      });
  }, [products]);

  const performAPICall = async () => {
    try {
      const res = await axios.get(`${config.endpoint}/products`);
      setProducts(res.data);
    } catch (e) {
      enqueueSnackbar("Something went wrong. Check the backend console for more details", {
        variant: "error",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const performSearch = async (text) => {
    try {
      const res = await axios.get(`${config.endpoint}/products/search?value=${text}`);
      setProducts(res.data);
    } catch (e) {
      if (e.response) {
        if (e.response.status === 404) {
          setProducts([]);
        }
        if (e.response.status === 500) {
          enqueueSnackbar(e.response.data.message, {
            variant: "error",
          });
        }
      } else {
        enqueueSnackbar("Something went wrong.", {
          variant: "error",
        });
      }
    }
  };

  const fetchCart = async (token) => {
    if (!token) return;

    try {
      const response = await axios.get(`${config.endpoint}/cart`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (e) {
      if (e.response && e.response.status === 400) {
        enqueueSnackbar(e.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar("Could not fetch cart details. Check that the backend is running.", {
          variant: "error",
        });
      }
      return null;
    }
  };

  const debounceSearch = (event, debounceTimeout) => {
    clearTimeout(debounceTimeout);
    let timerId = setTimeout(() => {
      performSearch(event.target.value);
    }, 800);
    setDebounceTimeout(timerId);
  };

  const isItemInCart = (productId) => {
    return items.find((item) => item.productId === productId) ? true : false;
  };

 const addToCart = async (productId, qty, options = { preventDuplicate: false }) => {
  if (!token) {
    enqueueSnackbar("Login to add an item to the cart", { variant: "warning" });
    return;
  }

  if (isItemInCart(productId) && options.preventDuplicate) {
    enqueueSnackbar("Item already in cart", { variant: "warning" });
    return;
  }

  try {
    const response = await axios.post(
      `${config.endpoint}/cart`,
      {
        productId: productId,
        qty: qty,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    const cartDetails = generateCartItemsFrom(response.data, products);
    setItems(cartDetails);

    enqueueSnackbar("Item has been added to the cart", { variant: "success" });
  } catch (e) {
    if (e.response && e.response.status === 400) {
      enqueueSnackbar(e.response.data.message, { variant: "error" });
    } else {
      enqueueSnackbar("item already in cart", { variant: "error" });
    }
  }
};


  return (
    <div>
      <Header>
        <TextField
          className="search-desktop"
          size="small"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search color="primary" />
              </InputAdornment>
            ),
          }}
          placeholder="Search for items/categories"
          name="search"
          onChange={(e) => {
            debounceSearch(e, debounceTimeout);
          }}
        />
      </Header>

      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
        onChange={(e) => {
          debounceSearch(e, debounceTimeout);
        }}
      />

      <Grid container>
        <Grid item xs={12} md={token && products.length > 0 ? 9 : 12} className="product-grid">
          <Box className="hero">
            <p className="hero-heading">
              India’s <span className="hero-highlight">FASTEST DELIVERY</span> to your doorstep
            </p>
          </Box>

          {isLoading ? (
            <Box className="loading">
              <CircularProgress />
              <Typography variant="body1">Loading Products...</Typography>
            </Box>
          ) : products.length ? (
            <Grid container spacing={2} marginY={0.5} paddingX={1}>
              {products.map((product) => (
                <Grid key={product._id} item xs={6} md={3}>
                  <ProductCard
                    product={product}
                    handleAddToCart={() => addToCart(product._id, 1, { preventDuplicate: true })}
                  />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Box className="loading">
              <SentimentDissatisfied />
              <Typography variant="body1">No Products Found</Typography>
            </Box>
          )}
        </Grid>
        {token ? (
          <Grid item xs={12} md={3} bgcolor="#E9F5E1">
            <Cart products={products} items={items} handleQuantity={addToCart} hasCheckotButton/>
          </Grid>
        ) : null}
      </Grid>
      <Footer />
    </div>
  );
};

export default Products;
